import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const PlanExpiryModal = ({ show, message, onClose }) => {
  return (
    <>
      <style>{`
        .plan-expiry-modal .modal-content {
          border: none;
          border-radius: 24px;
          overflow: hidden;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          padding: 3px;
        }
        
        .plan-expiry-modal .modal-body {
          background: #ffffff;
          border-radius: 22px;
          padding: 3rem;
        }
        
        .plan-expiry-modal .modal-backdrop.show {
          background-color: rgba(0, 0, 0, 0.6);
          backdrop-filter: blur(8px);
        }
        
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
        
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }
        
        .float-icon {
          animation: float 3s ease-in-out infinite;
        }
        
        
        .renew-btn {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
          border: none !important;
          border-radius: 12px !important;
          padding: 14px 32px !important;
          font-weight: 600 !important;
          color: #ffffff !important;
          box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4) !important;
          transition: all 0.3s ease !important;
          display: inline-flex !important;
          align-items: center !important;
          gap: 8px !important;
        }
        
        .renew-btn:hover {
          transform: translateY(-2px) !important;
          box-shadow: 0 8px 20px rgba(102, 126, 234, 0.5) !important;
          background: linear-gradient(135deg, #5a67d8 0%, #6b42a0 100%) !important;
        }
        
        .later-btn {
          background: #f9fafb !important;
          border: 2px solid #e5e7eb !important;
          border-radius: 12px !important;
          padding: 14px 32px !important;
          font-weight: 600 !important;
          color: #374151 !important;
          transition: all 0.2s !important;
        }
        
        .later-btn:hover {
          background: #f3f4f6 !important;
          border-color: #d1d5db !important;
          color: #374151 !important;
        }
        
        .action-badge {
          display: inline-block;
          background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
          padding: 6px 14px;
          border-radius: 20px;
          margin-bottom: 1rem;
        }
        
        .action-badge span {
          color: #dc2626;
          font-size: 0.75rem;
          font-weight: 700;
          letter-spacing: 0.5px;
          text-transform: uppercase;
        }
        
        .gradient-heading {
          font-weight: 700;
          font-size: 2rem;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          margin-bottom: 0.75rem;
          line-height: 1.2;
        }
        
        .glow-bg {
          position: absolute;
          width: 200px;
          height: 200px;
          background: linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%);
          border-radius: 50%;
          filter: blur(30px);
          z-index: 0;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        
        .illustration-wrapper {
          position: relative;
          text-align: center;
        }
      `}</style>

      <Modal
        show={show}
        onHide={onClose}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="plan-expiry-modal"
        size="lg"
      >
        <Modal.Body>
          <div style={{ display: 'flex', alignItems: 'center', gap: '2.5rem' }}>
            {/* Left Illustration */}
            <div className="illustration-wrapper" style={{ flex: '1' }}>
              <div className="glow-bg" />
              <img
                src="https://cdn-icons-png.flaticon.com/512/7077/7077313.png"
                alt="Plan Expired"
                className="float-icon"
                style={{ 
                  width: '200px', 
                  height: 'auto',
                  position: 'relative',
                  zIndex: 1,
                  filter: 'drop-shadow(0 10px 20px rgba(0, 0, 0, 0.1))',
                }}
              />
            </div>

            {/* Right Content */}
            <div style={{ flex: '1.3' }}>
              <div className="action-badge">
                <span>Action Required</span>
              </div>

              <h2 className="gradient-heading">
                Your Plan Is Expiring
              </h2>
              
              <p style={{ 
                color: '#6b7280', 
                fontSize: '1rem', 
                marginBottom: '2rem',
                lineHeight: '1.6',
              }}>
                {message || 'Continue enjoying premium features and unlock your full potential. Renew now to get back on track!'}
              </p>

              <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                
                <Button
                  onClick={onClose}
                  className="later-btn"
                >
                  Close
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PlanExpiryModal;